import React from 'react';
import TabBar from '../components/TabBar';

const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#f9f9f9] text-[#333] select-none">
      {children}
      <TabBar />
    </div>
  );
};

export default MainLayout;